import ProgressSpinner from "@/Shared/Icons/ProgressSpinner";
import { ProgressSpinnerSizes } from "@/Shared/Icons/ProgressSpinnerSizes";

function PageLoadingSpinner() {
  return (
    <div className="flex flex-col items-center" style={{ marginTop: "300px" }}>
      <ProgressSpinner size={ProgressSpinnerSizes.Small} />
    </div>
  );
}
export default PageLoadingSpinner;
